import { Glyphicon } from 'react-bootstrap';

export const RendererHelper = {
    renderPositiveNegative: (value: string, inverse: boolean = false) => {
        if (value == 'POS') {
            return <Glyphicon glyph='plus-sign' style={{ color: !inverse ? '#c00' : null }} />;
        }

        return <Glyphicon glyph='minus-sign' style={{ color: !inverse ? '#0c0' : null }} />;;
    }
}